import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../../shared/services/api.service";
import {Collection} from "../../../shared/interfaces/collection.interface";
import {Router} from "@angular/router";
import _orderBy from 'lodash/orderBy'
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  countShown = 6
  loading = false
  collections: Collection[] = []

  constructor(private apiService: ApiService,
              private router: Router,
              private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Palettes')

    this.loading = true
    this.apiService.getCollections()
      .subscribe((c: Collection[]) => {
        this.collections = _orderBy(c.filter(_c => _c.colors.length > 2), ['score'], ['desc'])
        this.loading = false
      })
  }

  newCollection() {
    this.apiService
      .postCollection({ title: 'New Palette', colors: [] })
      .subscribe((c: Collection) => this.router.navigate(['/' + c.id]))
  }

  showMore() {
    this.countShown += 6
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/home/containers/home/home.component.ts